module.exports = __webpack_public_path__ + "root-b33b72b3/XING-Sans-Regular-bdc063ec50e5759ac9d4d895679c1380.woff2";